import React, { forwardRef, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import MuiDialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { CardLayoutProvider } from './CardLayoutContext';
import { CardLayout } from './CardLayout';
import * as S from './CardLayoutStyled';

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export const CardLayoutDialog = ({ children, isOpen, fullScreen = true, onClose }) => {
  const [isFullScreen, setIsFullScreen] = useState(fullScreen);

  const closeHandler = useCallback(
    e => {
      e?.stopPropagation();
      onClose?.(e);
    },
    [onClose]
  );

  const fullScreenHandler = useCallback(() => {
    setIsFullScreen(prev => !prev);
  }, []);

  const contextValue = useMemo(
    () => ({ closeHandler, fullScreenHandler, isFullScreen }),
    [closeHandler, fullScreenHandler, isFullScreen]
  );

  return (
    isOpen && (
      <S.DialogWrapper
        fullScreen={isFullScreen}
        fullWidth
        // A hardcoded "xl" (MUI's ~1536px breakpoint) caps MuiPaper-root's width via MUI's own
        // internal max-width style even when our CSS sets width: 100% for fullScreen -- that
        // rule wins the specificity fight, so fullScreen never actually reached the viewport
        // edges on wider screens. Only cap the width when NOT fullScreen.
        maxWidth={isFullScreen ? false : 'xl'}
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={closeHandler}>
        <MuiDialogContent>
          <CardLayoutProvider value={contextValue}>
            <CardLayout>{children}</CardLayout>
          </CardLayoutProvider>
        </MuiDialogContent>
      </S.DialogWrapper>
    )
  );
};

CardLayoutDialog.displayName = 'CardLayoutDialog';
CardLayoutDialog.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool,
  onClose: PropTypes.func
};
